export enum BusinessLPPType {
  OBLIGATORY = 'OBLIGATORY',
  SUPOBLIGATORY = 'SUPOBLIGATORY',
}

export const getBusinessLPPTypeLabel = (type: BusinessLPPType): string => {
  switch (type) {
    case BusinessLPPType.OBLIGATORY:
      return $localize`LPP obligatoire`;
    case BusinessLPPType.SUPOBLIGATORY:
      return $localize`LPP surobligatoire`;
    default:
      return type;
  }
};
